
export default {
	name: "InstructionCard",
	props: {
		title: {
			required: true,
			type: String,
		},
		icon: {
			required: false,
			type: String,
		},
		intro: {
			required: true,
			type: String,
		},
	},
	computed: {
		defaultIcon() {
			return require(`~/assets/icons/${this.icon}`);
		},
	},
};
